<template>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <fieldset>
          <legend>
            Witnesses
            <div class="card-header-buttons float-right" v-if="!readonly">
              <button
                class="btn btn btn-primary"
                type="button"
                v-on:click="addWitnessModal"
              >
                Add Witness
              </button>
              <form-button
                :indicator="indicator"
                v-on:clicked="markAsNoWitnesses"
                level="danger"
                v-if="!markedAsNoWitnesses"
                >No Witnesses
              </form-button>
            </div>
          </legend>
        </fieldset>
        <div
          class="alert alert-info"
          v-if="!hasWitnesses && !markedAsNoWitnesses"
        >
          <p class="mb-0">
            You haven't added any witnesses. Please click the "Add Witness"
            button to add one.
          </p>
        </div>
        <div class="alert alert-info" v-if="markedAsNoWitnesses">
          <p class="mb-0">
            You have marked this hire has having no witness. To add a witness,
            please click the "Add Witness" button.
          </p>
        </div>
        <table
          class="table carpenter table-bordered table-hover"
          v-if="hasWitnesses"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Email Address</th>
              <th>Telephone</th>
              <th>Corroborate</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-bind:key="index"
              v-for="(witness, index) in witnesses"
              v-on:click="openEditWitnessModal(witness)"
              :style="readonly ? { cursor: 'default' } : {}"
            >
              <td>{{ witness.first_name }} {{ witness.last_name }}</td>
              <td>{{ witness.email_address }}</td>
              <td>
                {{ witness.telephone ? witness.telephone : 'Not Provided' }}
              </td>
              <td>{{ witness.corroborate ? 'Yes' : 'No' }}</td>
            </tr>
          </tbody>
        </table>

        <add-witness
          :incident="incident"
          v-if="modals.witness.add"
          v-on:close="closeAddWitnessModal"
          :titles="titles"
          v-on:added="witnessWasAdded"
        ></add-witness>

        <edit-witness
          :incident="incident"
          v-if="modals.witness.edit"
          v-on:close="closeEditWitnessModal"
          :titles="titles"
          :witness="editingWitness"
          v-on:deleted="removeWitness"
          v-on:updated="witnessWasUpdated"
          :readonly="readonly"
        ></edit-witness>
      </div>
      <div class="col-lg-6">
        <fieldset>
          <legend>
            Police Reports
            <div class="card-header-buttons float-right" v-if="!readonly">
              <button
                class="btn btn btn-primary"
                type="button"
                v-on:click="addReportModal"
              >
                Add Report
              </button>
            </div>
          </legend>
        </fieldset>
        <div class="alert alert-info" v-if="!hasReports">
          <p class="mb-0">
            You haven't added any reports. Please click the "Add Report" button
            to add one.
          </p>
        </div>
        <table class="table carpenter table-bordered table-hover" v-else>
          <thead>
            <tr>
              <th>Officer Name/Number</th>
              <th>Officer Attended</th>
              <th>Client Breathalysed</th>
              <th>TP Breathalysed</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-bind:key="index"
              v-for="(report, index) in reports"
              v-on:click="openEditReportModal(report)"
              :style="readonly ? { cursor: 'default' } : {}"
            >
              <td>
                {{ report.officer_name ? report.officer_name : 'Not Provided' }}
              </td>
              <td>{{ report.officer_attended ? 'Yes' : 'No' }}</td>
              <td>{{ report.client_breathalysed ? 'Yes' : 'No' }}</td>
              <td>{{ report.third_party_breathalysed ? 'Yes' : 'No' }}</td>
            </tr>
          </tbody>
        </table>

        <add-report
          :incident="incident"
          v-if="modals.reports.add"
          v-on:close="closeAddReportModal"
          v-on:added="reportWasAdded"
        ></add-report>

        <edit-report
          :incident="incident"
          v-if="modals.reports.edit"
          v-on:close="closeEditReportModal"
          :report="editingReport"
          v-on:deleted="removeReport"
          v-on:updated="reportWasUpdated"
          :readonly="readonly"
        ></edit-report>
      </div>
    </div>
  </div>
</template>
<script>
import AddWitness from './Children/AddWitness.vue';
import EditWitness from './Children/EditWitness.vue';
import AddReport from './Children/AddReport.vue';
import EditReport from './Children/EditReport.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    policeReports: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    AddWitness,
    EditWitness,
    AddReport,
    EditReport
  },

  data() {
    return {
      modals: {
        witness: {
          add: false,
          edit: false
        },
        reports: {
          add: false,
          edit: false
        }
      },
      editingWitness: null,
      editingReport: null,
      indicator: false
    };
  },

  computed: {
    reports() {
      return this.$store.getters['Incident/policeReports'];
    },

    markedAsNoWitnesses() {
      return !this.$store.getters['Incident/hasWitnesses'];
    },

    witnesses() {
      return this.$store.getters['Incident/witnesses'];
    },

    titles() {
      return this.$store.getters['Titles/all'];
    },

    hasReports() {
      return !!this.reports.length;
    },

    hasWitnesses() {
      return !!this.witnesses.length;
    }
  },

  methods: {
    markAsNoWitnesses() {
      if (this.readonly) return;
      window
        .swal({
          title: 'Are you sure?',
          text: 'This will remove all current witnesses',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete('/incidents/' + this.incident + '/witnesses')
              .then(response => {
                this.$store.commit('Incident/removeWitnesses');
                this.$store.commit('Incident/setHasWitnesses', false);
                window.toastify.success(
                  'Witnesses Removed',
                  'The witnesses were removed successfully!'
                );
                this.indicator = false;
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error removing the witnesses.'
                );
              });
          }
        })
        .catch(window.swal.noop);
    },

    findIndex(identifier) {
      return this.witnesses.findIndex(item => {
        return item.identifier === identifier;
      });
    },

    findReportIndex(identifier) {
      return this.reports.findIndex(item => {
        return item.identifier === identifier;
      });
    },

    removeWitness(witness) {
      this.closeEditWitnessModal();

      this.$store.commit('Incident/removeWitness', witness);

      window.toastify.success(
        'Witness Deleted',
        'The witness was deleted successfully!'
      );
    },

    witnessWasUpdated(witness) {
      this.closeEditWitnessModal();

      this.$store.commit('Incident/updateWitness', witness);

      window.toastify.success(
        'Success!',
        'The witness was updated successfully!'
      );
    },

    closeEditWitnessModal() {
      this.modals.witness.edit = false;
      this.editingWitness = null;
    },

    openEditWitnessModal(witness) {
      this.editingWitness = witness;
      this.modals.witness.edit = true;
    },

    witnessWasAdded(witness) {
      this.$store.commit('Incident/addWitness', witness);
      this.$store.commit('Incident/setHasWitnesses', true);
      this.closeAddWitnessModal();
      this.$emit('updated', true);
      window.toastify.success(
        'Success!',
        'The witness was added successfully!'
      );
    },

    addWitnessModal() {
      this.modals.witness.add = true;
    },

    closeAddWitnessModal() {
      this.modals.witness.add = false;
    },

    addReportModal() {
      this.modals.reports.add = true;
    },

    closeAddReportModal() {
      this.modals.reports.add = false;
    },

    closeEditReportModal() {
      this.modals.reports.edit = false;
      this.editingReport = null;
    },

    openEditReportModal(report) {
      this.editingReport = report;
      this.modals.reports.edit = true;
    },

    removeReport(report) {
      this.closeEditReportModal();

      this.$store.commit('Incident/removePoliceReport', report);

      window.toastify.success(
        'Report Deleted',
        'The report was deleted successfully!'
      );
    },

    reportWasUpdated(report) {
      this.closeEditReportModal();

      this.$store.commit('Incident/updatePoliceReport', report);

      window.toastify.success(
        'Success!',
        'The report was updated successfully!'
      );
    },

    reportWasAdded(report) {
      this.$store.commit('Incident/addPoliceReport', report);
      this.closeAddReportModal();
      window.toastify.success('Success!', 'The report was added successfully!');
    }
  }
};
</script>
